<template>
  <div>
    <layout-navbar></layout-navbar>
    <layout-header></layout-header>
    <layout-footer></layout-footer>
    <layout-body></layout-body>
  </div>
</template>

<script>
import LayoutHeader from './components/layout/Header.vue';
import LayoutNavbar from './components/layout/Navbar.vue';
import LayoutBody from './components/layout/Body.vue';
import LayoutFooter from './components/layout/Footer.vue';

export default {
  components: {
    LayoutHeader,
    LayoutNavbar,
    LayoutBody,
    LayoutFooter
  }
};
</script>
